import { ResourcesManager, ResourceType, Viewer, ViewerModule } from '@verybigthings/vbt-webvr-framework';
import { Euler, Mesh, MeshBasicMaterial, Quaternion, Sphere, SphereGeometry, Vector3 } from 'three';
import { MaterialImprovement } from '../../../utils/MaterialImprovement';
export class Water extends ViewerModule {
    constructor() {
        super();
        this.drops = [];
        this.dropsMaterial = new MeshBasicMaterial({ color: 'blue' });
        this.dropsGeometry = new SphereGeometry(0.03);
        this.resourcesInUse.push({
            name: 'water_dist',
            type: ResourceType.FBX_MODEL,
            priority: 0,
            url: require('../../../../assets/models/spectrophotometer/water_dist.fbx')
        });
        // const debugPoint1 = window['debugPoint1'] = new Mesh(new SphereGeometry(0.1), new MeshBasicMaterial({color: 'red'}));
        // const debugPoint2 = window['debugPoint2'] = new Mesh(new SphereGeometry(0.1), new MeshBasicMaterial({color: 'red'}));
        // this.addObject(debugPoint1);
        // this.addObject(debugPoint2);
        // debugPoint1.position.set(-0.2485072915583678, 0.6784305194592513, -0.005795799326461623);
        // debugPoint2.position.set(0.288602753935415, 0, 0.02362715450653783);
        const topPoint = new Vector3(-0.2485072915583678, 0.6784305194592513, -0.005795799326461623);
        const bottomPoint = new Vector3(0.288602753935415, 0, 0.02362715450653783);
        this.onUpdateCallback = () => {
            if (this.model.children[0].localToWorld(topPoint.clone()).y <= this.model.children[0].localToWorld(bottomPoint.clone()).y) {
                let drop;
                this.drops.push(drop = new Mesh(this.dropsGeometry, this.dropsMaterial));
                Viewer.scene.add(drop);
                drop.scale.multiplyScalar(Math.random() + 0.5);
                drop.position.copy(this.model.children[0].localToWorld(topPoint.clone()));
                drop.userData.sphere = new Sphere(drop.position, 0.03 * drop.scale.x);
            }
            this.drops.slice().forEach(drop => {
                drop.position.y -= 0.05;
                if (drop.position.y < -18.9) {
                    this.removeDrop(drop);
                }
                else {
                    drop.userData.sphere.center.copy(drop.position);
                }
            });
        };
    }
    init() {
        if (this.model)
            this.removeObject(this.model);
        this.addObject(this.model = ResourcesManager.getModel('water_dist').clone());
        MaterialImprovement.upgradeMaterialsFromModel(this.model, 'water_dist');
        // this.setDynamicLiquidMode(true);
    }
    setDynamicLiquidMode(enabled) {
        if (enabled) {
            Viewer.on('update', this.onUpdateCallback);
        }
        else {
            this.onUpdateCallback && Viewer.off('update', this.onUpdateCallback);
            this.drops.slice().forEach(drop => {
                this.removeDrop(drop);
            });
        }
    }
    reset() {
        this.init();
    }
    visibilityShadow(visibility = true) {
        const pPlane = this.model.getObjectByName('pPlane');
        if (pPlane)
            pPlane.visible = visibility;
    }
    setAsPointerControllerObject(toggle) {
        if (!this.model)
            return;
        return new Promise(resolve => {
            let newPosition, newRotation;
            if (toggle) {
                newPosition = new Vector3(0.6813587609139211, 0.26469661085900625, 0);
                newRotation = new Quaternion().setFromEuler(new Euler(0, 0, Math.PI / 2));
                this.visibilityShadow(false);
            }
            else {
                newPosition = new Vector3(0, 0, 0);
                newRotation = new Quaternion().setFromEuler(new Euler(0, 0, 0));
                this.visibilityShadow(true);
            }
            const oldRotation = this.model.children[0].quaternion.clone(), oldPosition = this.model.children[0].position.clone();
            new TWEEN.Tween(this.model.children[0].position).to(newPosition, 1500)
                .easing(TWEEN.Easing.Quadratic.Out)
                .onUpdate((alpha) => {
                this.model.children[0].quaternion.copy(oldRotation.clone().slerp(newRotation, alpha));
            })
                .onComplete(() => {
                resolve();
            })
                .start();
        });
    }
    removeDrop(drop) {
        drop.parent && drop.parent.remove(drop);
        this.drops.splice(this.drops.indexOf(drop), 1);
    }
    dispose() {
        super.dispose();
        this.drops.forEach(drop => { drop.parent && drop.parent.remove(drop); });
        this.dropsGeometry.dispose();
        this.dropsMaterial.dispose();
    }
}
